import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './context/AuthContext'
import Layout from './components/Layout'
import LoginPage from './pages/LoginPage'
import SignupPage from './pages/SignupPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import LandingPage from './pages/LandingPage'
import TermsPage from './pages/TermsPage'
import PrivacyPage from './pages/PrivacyPage'
import DashboardPage from './pages/DashboardPage'
import LeadsPage from './pages/LeadsPage'
import ContactsPage from './pages/ContactsPage'
import DealsPage from './pages/DealsPage'
import EventsPage from './pages/EventsPage'
import BEOPage from './pages/BEOPage'
import CalendarPage from './pages/CalendarPage'
import ReportsPage from './pages/ReportsPage'
import PacePage from './pages/PacePage'
import SpacePage from './pages/SpacePage'
import AvailabilityPage from './pages/AvailabilityPage'
import GroupResumePage from './pages/GroupResumePage'
import ProposalsPage from './pages/ProposalsPage'
import ContractsPage from './pages/ContractsPage'
import InvoicesPage from './pages/InvoicesPage'
import TeamPage from './pages/TeamPage'
import ProfilePage from './pages/ProfilePage'
import FunctionDiaryPage from './pages/FunctionDiaryPage'
import CateringPage from './pages/CateringPage'
import SettingsPage from './pages/SettingsPage'
import PublicProposalPage from './pages/PublicProposalPage'
import PublicContractPage from './pages/PublicContractPage'
import GuestPortalPage from './pages/GuestPortalPage'
import AdminLayout from './pages/admin/AdminLayout'
import AdminDashboard from './pages/admin/AdminDashboard'
import AdminHotels from './pages/admin/AdminHotels'
import AdminUsers from './pages/admin/AdminUsers'
import CorporateLayout from './pages/corporate/CorporateLayout'
import CorporateDashboard from './pages/corporate/CorporateDashboard'
import CorporateHotels from './pages/corporate/CorporateHotels'
import CorporateRegions from './pages/corporate/CorporateRegions'
import CorporateTeam from './pages/corporate/CorporateTeam'
import CorporateHotelView from './pages/corporate/CorporateHotelView'

function HomePage() {
  const { user, isCorporate } = useAuth()
  if (!user) return <Navigate to="/landing" replace />
  if (isCorporate()) return <Navigate to="/corporate" replace />
  return <Navigate to="/dashboard" replace />
}

export default function App() {
  const { user } = useAuth()

  return (
    <Routes>
      {/* Public pages */}
      <Route path="/landing" element={<LandingPage />} />
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/signup" element={user ? <Navigate to="/" replace /> : <SignupPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/public/proposal/:token" element={<PublicProposalPage />} />
      <Route path="/public/contract/:token" element={<PublicContractPage />} />
      <Route path="/portal/:token" element={<GuestPortalPage />} />

      {/* Platform Admin */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="hotels" element={<AdminHotels />} />
        <Route path="users" element={<AdminUsers />} />
      </Route>

      {/* Corporate Portal */}
      <Route path="/corporate" element={<CorporateLayout />}>
        <Route index element={<CorporateDashboard />} />
        <Route path="hotels" element={<CorporateHotels />} />
        <Route path="regions" element={<CorporateRegions />} />
        <Route path="team" element={<CorporateTeam />} />
      </Route>

      {/* Corporate Drill-In */}
      <Route path="/corporate/hotel-view" element={<CorporateHotelView />}>
        <Route index element={<DashboardPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="group-resume" element={<GroupResumePage />} />
      </Route>

      {/* Root redirect */}
      <Route path="/" element={<HomePage />} />

      {/* Hotel CRM */}
      <Route element={<Layout />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/leads" element={<LeadsPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="/deals" element={<DealsPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/beos" element={<BEOPage />} />
        <Route path="/function-diary" element={<FunctionDiaryPage />} />
        <Route path="/catering" element={<CateringPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/pace" element={<PacePage />} />
        <Route path="/space" element={<SpacePage />} />
        <Route path="/availability" element={<AvailabilityPage />} />
        <Route path="/group-resume" element={<GroupResumePage />} />
        <Route path="/proposals" element={<ProposalsPage />} />
        <Route path="/contracts" element={<ContractsPage />} />
        <Route path="/invoices" element={<InvoicesPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
